import React from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';

function ProfileSetup() {
  // Validation Schema
  const validationSchema = Yup.object({
    firstName: Yup.string().required("Required"),
    lastName: Yup.string().required("Required"),
    gender: Yup.string().required("Please select gender"),
    dob: Yup.date().required("Required"),
    address: Yup.string().min(10, "Please provide full address").required("Required"),
    city: Yup.string().required("Required"),
    pincode: Yup.string()
      .matches(/^[1-9][0-9]{5}$/, "Invalid PIN Code")
      .required("Required"),
  });

  const formik = useFormik({
    initialValues: {
      firstName: '',
      lastName: '',
      gender: 'Female', // Default selection
      dob: '1995-08-15',
      address: '',
      city: 'Patna',
      pincode: '800001',
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      console.log("Profile Data:", values);
      // window.location.href = "/home";
    },
  });

  return (
    <div className="scr on" id="s-psetup">
      <div className="gh" style={{ paddingTop: "20px" }}>
        <h2 style={{ fontSize: "1.5rem", fontWeight: 800 }}>Complete Your Profile 🌟</h2>
        <p >
          Help us customize your culinary experience.
        </p>
        <div className="ps-prog">
          <div className="ps-p a" />
          <div className="ps-p a" />
          <div className="ps-p a" />
        </div>
      </div>

      <div className="av-wrap">
        <div className="av-ring" style={{ cursor: 'pointer' }}>
          <img src="https://cdn-icons-png.flaticon.com/128/1144/1144709.png" style={{height:"90px"}}/>
          <div className="av-cam">
            <img src="https://cdn-icons-png.flaticon.com/128/10336/10336582.png" style={{height:"22px"}}/>
          </div>
        </div>
        <p style={{ fontSize: "0.75rem", fontWeight: 700, color: "var(--or)", marginTop: '8px' }}>
          Upload Profile Picture
        </p>
      </div>

      <form onSubmit={formik.handleSubmit} className="fs">
        <div className="f2">
          <div>
            <span className="fl">First Name</span>
            <input 
              name="firstName"
              className={`inp ${formik.errors.firstName && formik.touched.firstName ? 'err' : ''}`}
              onChange={formik.handleChange}
              value={formik.values.firstName}
              placeholder="e.g. Priya" 
            />
          </div>
          <div>
            <span className="fl">Last Name</span>
            <input 
              name="lastName"
              className={`inp ${formik.errors.lastName && formik.touched.lastName ? 'err' : ''}`}
              onChange={formik.handleChange}
              value={formik.values.lastName}
              placeholder="e.g. Sharma" 
            />
          </div>
        </div>

        <div className="fg-group">
          <span className="fl">Gender Identity</span>
          <div className="gb-row">
            {['Female', 'Male', 'Other'].map((g) => (
              <button
                key={g}
                type="button"
                className={`gb ${formik.values.gender === g ? 'sel' : ''}`}
                onClick={() => formik.setFieldValue('gender', g)}
              >
                {g === 'Female' ? '👩 ' : g === 'Male' ? '👨 ' : '⚧ '} {g}
              </button>
            ))}
          </div>
        </div>

        <div className="fg-group">
          <span className="fl">Date of Birth</span>
          <input 
            name="dob"
            className="inp" 
            type="date" 
            onChange={formik.handleChange}
            value={formik.values.dob}
          />
        </div>

        <div className="fg-group">
          <span className="fl">Delivery Address</span>
          <input 
            name="address"
            className="inp" 
            placeholder="Flat/House No., Floor, Building Name" 
            onChange={formik.handleChange}
            value={formik.values.address}
          />
          {formik.errors.address && formik.touched.address && 
            <small style={{color: 'red', fontSize: '0.7rem'}}>{formik.errors.address}</small>}
        </div>

        <div className="f2">
          <div>
            <span className="fl">City</span>
            <input 
              name="city"
              className="inp" 
              onChange={formik.handleChange}
              value={formik.values.city} 
            />
          </div>
          <div>
            <span className="fl">PIN Code</span>
            <input 
              name="pincode"
              className="inp" 
              type="number"
              onChange={formik.handleChange}
              value={formik.values.pincode} 
            />
          </div>
        </div>

        <button
          type="submit"
          className="btn btn-or btn-full"
          style={{ marginTop: 15, fontWeight: '700' }}
        >
          Explore Menu →
        </button>

        <div
          style={{
            textAlign: "center",
            marginTop: 15,
            fontSize: "0.8rem",
            color: "var(--muted)",
            fontWeight: 600,
            cursor: "pointer"
          }}
          onClick={() => console.log("Skipped")}
        >
          I'll do this later
        </div>
      </form>
    </div>
  );
}

export default ProfileSetup;